<template>
    <div class="nav-bar bg-white box-shadow">
        <RequiresGlobalPermissions v-bind:required-permissions="['DEVELOPER_MODE']">
            <nav class="navbar navbar-expand-lg navbar-light bg-light">
                <a class="nav-link">
                    <router-link class="p-2 text-dark" v-bind:to="{name:'list-device-models' }">
                        List device Models
                    </router-link>
                </a>
                <a class="nav-link">
                    <router-link class="p-2 text-dark" v-bind:to="{name: 'firmware-management'}">
                        Firmware
                    </router-link>
                </a>
            </nav>
        </RequiresGlobalPermissions>
      <router-view class="container-fluid"></router-view>
    </div>
</template>
<script>
import RequiresGlobalPermissions from "@/components/RequiresGlobalPermissions";

export default {
    components: {
      RequiresGlobalPermissions,
    },
  }
</script>
